'use strict';

import './icon.directive.scss';

export default angular
  .module('maestro.directives.components.icon', [])
  .directive('icon', () => {
    return {
      restrict: 'E',
      replace: true,
      template: '<svg class="svg-icon" fill="currentColor"></svg>',
      controller: (
        $scope,
        $element,
        $attrs,
        $log,
        IconService
      ) => {
        let iconName;
        $element = $($element);

        $attrs.$observe('i', relink);

        function relink(newIconName) {
          if (!newIconName || iconName === newIconName) {
            return;
          }
          iconName = newIconName;

          IconService.getSvgIcon(newIconName)
            .then(svg => {
              try {
                const viewBox = $(svg).attr('viewBox');
                if (viewBox) {
                  const [, , width, height] = viewBox.split(' ').map(e => parseInt(e));
                  if (width && height) {
                    $element.removeClass((index, className) => (className.match(/^fa-w-\d+/g) || []).join(' '));
                    $element.addClass(`fa-w-${Math.ceil(width / height * 16).toString()}`);
                  }
                }
              } catch (err) {
                $log.warn(`Unable to parse SVG icon "${newIconName}"`);
                $log.warn(err);
              }
              $element.html(`<g>${svg}</g>`);
            });
        }

      }
    };
  })
  .name;
